import { render, staticRenderFns } from "./category-filter.vue?vue&type=template&id=2a4c4bcc&scoped=true"
import script from "./category-filter.vue?vue&type=script&lang=js"
export * from "./category-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4c4bcc",
  null
  
)

export default component.exports